/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { externalProjectLinksControllerFindAll } from "./externalProjectLinksControllerFindAll";
import { externalProjectLinksControllerFindOne } from "./externalProjectLinksControllerFindOne";
import { externalProjectLinksControllerRemove } from "./externalProjectLinksControllerRemove";
import { externalProjectLinksControllerUpsert } from "./externalProjectLinksControllerUpsert";

export function externalProjectLinksService() {
  return { externalProjectLinksControllerUpsert, externalProjectLinksControllerFindAll, externalProjectLinksControllerFindOne, externalProjectLinksControllerRemove }
}